// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DSIK","top":"styles_top__1GE2S","left":"styles_left__14Ngn","description":"styles_description__2w-Dw"};